import { format } from 'date-fns';
import { DATE_FORMAT_YYYY_MM_DD } from 'src/components/DatePickerInput/DatePickerInput';

export const transformDateUIToModel = (date: Date | null): string => {
  return date ? format(date, DATE_FORMAT_YYYY_MM_DD) : '';
};
